import React from 'react';
import { EnvelopeIcon, LinkIcon, DocumentArrowDownIcon, SpinnerIcon } from '../../Icons';

interface MassShareActionsGridProps {
  isLoadingAction: string | null;
  onSelectBrochure: () => void;
  onCopyGroupLink: () => void;
  onDownloadCsv: () => void;
  onDownloadExcel: () => void;
}

export const MassShareActionsGrid: React.FC<MassShareActionsGridProps> = ({
  isLoadingAction,
  onSelectBrochure,
  onCopyGroupLink,
  onDownloadCsv,
  onDownloadExcel,
}) => {
  return (
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      <button
        onClick={onSelectBrochure}
        disabled={!!isLoadingAction}
        className="flex flex-col items-center p-5 bg-white border-2 border-gray-100 rounded-2xl hover:border-sky-200 hover:shadow-lg transition-all text-center disabled:opacity-50"
      >
        <div className="p-3 bg-sky-100 text-sky-600 rounded-full mb-2">
          <EnvelopeIcon className="w-6 h-6" />
        </div>
        <h4 className="font-bold text-gray-800 text-xs uppercase mb-1">Enviar Brochure</h4>
        <p className="text-[10px] text-gray-500">PDF por email (Max 30)</p>
      </button>

      <button
        onClick={onCopyGroupLink}
        disabled={!!isLoadingAction}
        className="flex flex-col items-center p-5 bg-white border-2 border-gray-100 rounded-2xl hover:border-sky-200 hover:shadow-lg transition-all text-center disabled:opacity-50"
      >
        <div className="p-3 bg-sky-100 text-sky-600 rounded-full mb-2">
          {isLoadingAction === 'link' ? (
            <SpinnerIcon className="w-6 h-6 animate-spin" />
          ) : (
            <LinkIcon className="w-6 h-6" />
          )}
        </div>
        <h4 className="font-bold text-gray-800 text-xs uppercase mb-1">Copiar Link</h4>
        <p className="text-[10px] text-gray-500">Vista grupal (Max 60)</p>
      </button>

      <button
        onClick={onDownloadCsv}
        disabled={!!isLoadingAction}
        className="flex flex-col items-center p-5 bg-white border-2 border-gray-100 rounded-2xl hover:border-emerald-200 hover:shadow-lg transition-all text-center disabled:opacity-50"
      >
        <div className="p-3 bg-emerald-100 text-emerald-600 rounded-full mb-2">
          {isLoadingAction === 'csv' ? (
            <SpinnerIcon className="w-6 h-6 animate-spin" />
          ) : (
            <DocumentArrowDownIcon className="w-6 h-6" />
          )}
        </div>
        <h4 className="font-bold text-gray-800 text-xs uppercase mb-1">Descargar CSV</h4>
        <p className="text-[10px] text-gray-500">Archivo de datos</p>
      </button>

      <button
        onClick={onDownloadExcel}
        disabled={!!isLoadingAction}
        className="flex flex-col items-center p-5 bg-white border-2 border-gray-100 rounded-2xl hover:border-green-200 hover:shadow-lg transition-all text-center disabled:opacity-50"
      >
        <div className="p-3 bg-green-100 text-green-700 rounded-full mb-2">
          {isLoadingAction === 'excel' ? (
            <SpinnerIcon className="w-6 h-6 animate-spin" />
          ) : (
            <DocumentArrowDownIcon className="w-6 h-6" />
          )}
        </div>
        <h4 className="font-bold text-gray-800 text-xs uppercase mb-1">Descargar Excel</h4>
        <p className="text-[10px] text-gray-500">Para MS Excel</p>
      </button>
    </div>
  );
};
